// import React, { useEffect, useMemo, useState } from "react";
// import {
//   FaExchangeAlt,
//   FaCheckCircle,
//   FaTimesCircle,
//   FaExclamationCircle,
//   FaCalendarDay,
//   FaStore,
//   FaCreditCard,
// } from "react-icons/fa";
// import { DataTable } from "primereact/datatable";
// import { Column } from "primereact/column";

// import "../styles/Dashboard.css";


// const UserDashboard = ({ isSidebarOpen }) => {
//   const [stats, setStats] = useState(null);
  
//   const [loading, setLoading] = useState(false);

//   // Load stats + transactions
//   useEffect(() => {
   
//   }, []);

 

//   if (loading) {
//     return (
//       <div className={`dashboard-container ${isSidebarOpen ? "shifted" : ""}`}>
//         <p className="loader">Loading dashboard...</p>
//       </div>
//     );
//   }

//   return (
//     <div className={`dashboard-container ${isSidebarOpen ? "shifted" : ""}`}>
//       {/* Tiles */}
//       {stats && (
//         <div className="tiles-grid">
//           {[
//             {
//               label: "Total Transactions",
//               value: stats.totalTransactions ?? 0,
//               color: "total",
//               icon: <FaExchangeAlt />,
//             },
//             {
//               label: "Settled Transactions",
//               value: stats.settledCount?? 0,
//               color: "settled",
//               icon: <FaCheckCircle />,
//             },
//             {
//               label: "Unsettled Transactions",
//               value: stats.unsettledCount?? 0,
//               color: "unsettled",
//               icon: <FaTimesCircle />,
//             },
//             {
//               label: "Disputed Transactions",
//               value: stats.disputedCount?? 0,
//               color: "disputed",
//               icon: <FaExclamationCircle />,
//             },
//             {
//               label: "Today's Transactions",
//               value: stats.todaysTransactions?? 0,
//               color: "today",
//               icon: <FaCalendarDay />,
//             },
//             {
//               label: "Total Merchants",
//               value: stats.merchantCount?? 0,
//               color: "merchants",
//               icon: <FaStore />,
//             },
//             {
//               label: "Total Terminals",
//               value: stats.terminalCount?? 0,
//               color: "terminals",
//               icon: <FaCreditCard />,
//             },
//           ].map((tile, index) => (
//             <div key={index} className={`tile ${tile.color}`}>
//               <div className="tile-header">
//                 <div className="tile-icon">{tile.icon}</div>
//                 <h3>{tile.label}</h3>
//               </div>
//               <p>{tile.value}</p>
//             </div>
//           ))}
//         </div>
//       )}

    
//     </div>
//   );
// };

// export default UserDashboard;
import React, { useEffect, useRef, useState } from "react";
import {
  FaExchangeAlt,
  FaCheckCircle,
  FaTimesCircle,
  FaExclamationCircle,
  FaCalendarDay,
  FaStore,
  FaCreditCard,
} from "react-icons/fa";
import { Chart, registerables } from "chart.js";
import "../styles/Dashboard.css";

Chart.register(...registerables);

const fmt = (n) => (n >= 1000 ? `${(n / 1000).toFixed(1)}k` : String(n));

function ChartCanvas({ id, config, height = 200 }) {
  const ref = useRef(null);
  const instanceRef = useRef(null);

  useEffect(() => {
    if (!ref.current || !config) return;
    if (instanceRef.current) instanceRef.current.destroy();
    instanceRef.current = new Chart(ref.current, config);
    return () => {
      if (instanceRef.current) instanceRef.current.destroy();
    };
  }, [config]);

  return (
    <div style={{ position: "relative", width: "100%", height }}>
      <canvas ref={ref} id={id} />
    </div>
  );
}

function lineConfig(labels, values, color) {
  const GRID = "rgba(255,255,255,0.08)";
  const TICK = "rgba(255,255,255,0.45)";
  return {
    type: "line",
    data: {
      labels,
      datasets: [
        {
          data: values,
          borderColor: color,
          borderWidth: 3,
          pointBackgroundColor: color,
          pointBorderColor: "rgba(255,255,255,0.9)",
          pointBorderWidth: 1,
          pointRadius: 0,
          pointHoverRadius: 5,
          fill: true,
          backgroundColor: (ctx) => {
            const g = ctx.chart.ctx.createLinearGradient(0, 0, 0, 220);
            g.addColorStop(0, color + "38");
            g.addColorStop(1, color + "00");
            return g;
          },
          tension: 0.45,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: { legend: { display: false } },
      scales: {
        x: { grid: { display: false }, ticks: { color: TICK, font: { size: 10 } } },
        y: {
          grid: { color: GRID, drawBorder: false },
          ticks: {
            color: TICK,
            font: { size: 10 },
            callback: (v) => (v >= 1000 ? `${(v / 1000).toFixed(0)}k` : v),
          },
        },
      },
    },
  };
}

function doughnutConfig(a, b, c) {
  return {
    type: "doughnut",
    data: {
      labels: ["Settled", "Unsettled", "Disputed"],
      datasets: [
        {
          data: [a, b, c],
          backgroundColor: ["#44EDCC", "#FFBA20", "#FFB4AB"],
          borderColor: [
            "rgba(68,237,204,0.45)",
            "rgba(255,186,32,0.45)",
            "rgba(255,180,171,0.45)",
          ],
          borderWidth: 1.5,
          hoverOffset: 8,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      cutout: "70%",
      plugins: { legend: { display: false } },
    },
  };
}

function Kpi({ label, value, icon, accent, trend }) {
  return (
    <div className="msd-kpi">
      <div className="msd-kpi__head">
        <div className="msd-kpi__label">{label}</div>
        <div
          className="msd-kpi__icon"
          style={{ color: accent, background: accent + "22" }}
        >
          {icon}
        </div>
      </div>
      <div className="msd-kpi__value">{value}</div>
      {trend ? <div className="msd-kpi__trend">{trend}</div> : null}
      <div
        className="msd-kpi__spark"
        style={{
          background: `linear-gradient(90deg, ${accent} 0%, transparent 80%)`,
        }}
      />
    </div>
  );
}

const UserDashboard = ({ isSidebarOpen }) => {
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    setLoading(true);
    const demo = {
      totalTransactions: 42100,
      settledCount: 38220,
      unsettledCount: 2660,
      disputedCount: 1220,
      todaysTransactions: 840,
      merchantCount: 14200,
      terminalCount: 2890,
      trend: [18000, 22000, 21000, 26000, 31000, 29000, 42000],
      trendLabels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    };
    const t = window.setTimeout(() => {
      setStats(demo);
      setLoading(false);
    }, 350);
    return () => window.clearTimeout(t);
  }, []);

  const activities = [
    {
      title: "Settlement Completed",
      desc: "Batch settlement processed successfully.",
      when: "2 mins ago",
    },
    {
      title: "Refund Issued",
      desc: "Refund issued for txn #10293.",
      when: "24 mins ago",
    },
    {
      title: "Dispute Opened",
      desc: "Chargeback raised for txn #8891.",
      when: "1 hour ago",
    },
    {
      title: "New Terminal Activated",
      desc: "Terminal TID-5521 went live.",
      when: "3 hours ago",
    },
  ];

  const topMerchants = [
    {
      name: "Velocity Retail",
      id: "#4920",
      volume: "Rs 245,000",
      success: "99.9%",
      status: "ACTIVE",
    },
    {
      name: "Aether Logistics",
      id: "#3122",
      volume: "Rs 182,400",
      success: "99.7%",
      status: "ACTIVE",
    },
    {
      name: "Zenith Hotels",
      id: "#9921",
      volume: "Rs 121,000",
      success: "94.2%",
      status: "REVIEW",
    },
    {
      name: "Nova Finance",
      id: "#2234",
      volume: "Rs 98,300",
      success: "99.8%",
      status: "ACTIVE",
    },
  ];

  if (loading || !stats) {
    return (
      <div className={`msd-container ${isSidebarOpen ? "shifted" : ""}`}>
        <p className="msd-muted">Loading dashboard…</p>
      </div>
    );
  }

  const total = Number(stats.totalTransactions ?? 0);
  const settled = Number(stats.settledCount ?? 0);
  const unsettled = Number(stats.unsettledCount ?? 0);
  const disputed = Number(stats.disputedCount ?? 0);
  const successRate = total ? (settled / total) * 100 : 0;
  const successRateText = `${successRate.toFixed(1)}%`;

  const tiles = [
    {
      label: "Total Txns",
      value: fmt(total),
      icon: <FaExchangeAlt />,
      accent: "#44EDCC",
      trend: "↑ 12%",
    },
    {
      label: "Settled",
      value: fmt(settled),
      icon: <FaCheckCircle />,
      accent: "#44EDCC",
      trend: "↑ 8%",
    },
    {
      label: "Unsettled",
      value: fmt(unsettled),
      icon: <FaTimesCircle />,
      accent: "#FFBA20",
      trend: "↗",
    },
    {
      label: "Disputed",
      value: fmt(disputed),
      icon: <FaExclamationCircle />,
      accent: "#FFB4AB",
      trend: "⚠",
    },
    {
      label: "Today",
      value: fmt(stats.todaysTransactions ?? 0),
      icon: <FaCalendarDay />,
      accent: "#B6C4FF",
      trend: "↗",
    },
    {
      label: "Merchants",
      value: fmt(stats.merchantCount ?? 0),
      icon: <FaStore />,
      accent: "#A855F7",
      trend: "↑",
    },
    {
      label: "Success Rate",
      value: successRateText,
      icon: <FaCreditCard />,
      accent: "#44EDCC",
      trend: "Stable",
    },
  ];

  const trendValues = Array.isArray(stats.trend) ? stats.trend : [];
  const trendLabels = Array.isArray(stats.trendLabels) ? stats.trendLabels : [];
  const trendConf = trendValues.length
    ? lineConfig(trendLabels, trendValues, "#0057FF")
    : null;
  const donutConf = doughnutConfig(settled, unsettled, disputed);

  return (
    <div className={`msd-container ${isSidebarOpen ? "shifted" : ""}`}>
      <div className="msd-kpis">
        {tiles.map((t, i) => (
          <Kpi
            key={i}
            label={t.label}
            value={t.value}
            icon={t.icon}
            accent={t.accent}
            trend={t.trend}
          />
        ))}
      </div>

      <div className="msd-maingrid">
        <div className="msd-card msd-card--wide">
          <div className="msd-card__head">
            <div>
              <div className="msd-card__title">Transaction Trends</div>
              <div className="msd-card__subtitle">Your weekly volume pattern</div>
            </div>
          </div>
          <div className="msd-card__body">
            <ChartCanvas id="user-trend" config={trendConf} height={240} />
          </div>
        </div>

        <div className="msd-card">
          <div className="msd-card__head">
            <div>
              <div className="msd-card__title">Transaction Status</div>
              <div className="msd-card__subtitle">Settled vs unsettled</div>
            </div>
          </div>
          <div className="msd-card__body msd-donut">
            <div className="msd-donut__chart">
              <ChartCanvas id="user-status" config={donutConf} height={180} />
            </div>
            <div className="msd-donut__legend">
              <div className="msd-legend-row">
                <span className="msd-dot" style={{ background: "#44EDCC" }} />
                Settled
                <span className="msd-legend-val">{fmt(settled)}</span>
              </div>
              <div className="msd-legend-row">
                <span className="msd-dot" style={{ background: "#FFBA20" }} />
                Unsettled
                <span className="msd-legend-val">{fmt(unsettled)}</span>
              </div>
              <div className="msd-legend-row">
                <span className="msd-dot" style={{ background: "#FFB4AB" }} />
                Disputed
                <span className="msd-legend-val">{fmt(disputed)}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="msd-bottomgrid">
        <div className="msd-card">
          <div className="msd-card__head">
            <div>
              <div className="msd-card__title">Recent Activities</div>
              <div className="msd-card__subtitle">Updates & events</div>
            </div>
          </div>
          <div className="msd-activity">
            {activities.map((a) => (
              <div key={a.title} className="msd-activity__row">
                <div className="msd-activity__meta">
                  <div className="msd-activity__title">{a.title}</div>
                  <div className="msd-activity__desc">{a.desc}</div>
                </div>
                <div className="msd-activity__when">{a.when}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="msd-card msd-card--wide">
          <div className="msd-card__head">
            <div>
              <div className="msd-card__title">Top Merchants</div>
              <div className="msd-card__subtitle">Daily volume and success rate</div>
            </div>
          </div>
          <div className="msd-table">
            <div className="msd-table__head">
              <div>Merchant</div>
              <div>Daily Volume</div>
              <div>Success Rate</div>
              <div>Status</div>
            </div>
            {topMerchants.map((o) => (
              <div key={o.name} className="msd-table__row">
                <div className="msd-org">
                  <div className="msd-org__avatar">{o.name.slice(0, 1)}</div>
                  <div style={{ minWidth: 0 }}>
                    <div className="msd-org__name">{o.name}</div>
                    <div
                      className="msd-muted"
                      style={{ margin: 0, textAlign: "left", fontSize: 10 }}
                    >
                      ID: {o.id}
                    </div>
                  </div>
                </div>
                <div className="msd-mono">{o.volume}</div>
                <div
                  className="msd-mono"
                  style={{ color: o.status === "REVIEW" ? "#FFB4AB" : "#44EDCC" }}
                >
                  {o.success}
                </div>
                <div>
                  <span
                    className={
                      o.status === "ACTIVE"
                        ? "msd-badge msd-badge--active"
                        : "msd-badge msd-badge--review"
                    }
                  >
                    {o.status}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDashboard;